// External libraries
import gql from 'graphql-tag';

export const SIGN_UP_NEW_MEMBER_MUTATION = gql`
  mutation SignUpNewMemberMutation(
    $bank: BankAccountInput
    $billingAddress: AddressInput
    $card: CardInput
    $contentIdentifier: String
    $country: CountryCodes
    $currencyConversionType: CheckoutCurrencyConversionType
    $dateOfBirth: DateOfBirth
    $email: String!
    $firstName: String!
    $gender: Gender
    $identityDocument: IdentityDocumentInput
    $lastName: String!
    $marketingOptOut: Boolean
    $nationality: CountryCodes
    $occupation: Occupation
    $password: String
    $phone: PhoneInput!
    $placeOfBirth: CountryCodes
    $secondaryIdentityDocument: IdentityDocumentInput
    $selectedInstallmentOption: InstallmentsInput
    $shareAddressWithDonatee: Boolean
    $shippingAddress: AddressInput
    $supportedThreeDsExperiences: [ThreeDSPaymentExperience]
    $token: String!
  ) {
    onboardAccount: signUpNewMember(
      bank: $bank
      billingAddress: $billingAddress
      card: $card
      contentIdentifier: $contentIdentifier
      country: $country
      currencyConversionType: $currencyConversionType
      dateOfBirth: $dateOfBirth
      email: $email
      firstName: $firstName
      gender: $gender
      identityDocument: $identityDocument
      lastName: $lastName
      marketingOptOut: $marketingOptOut
      nationality: $nationality
      occupation: $occupation
      password: $password
      phone: $phone
      placeOfBirth: $placeOfBirth
      secondaryIdentityDocument: $secondaryIdentityDocument
      selectedInstallmentOption: $selectedInstallmentOption
      shareAddressWithDonatee: $shareAddressWithDonatee
      shippingAddress: $shippingAddress
      token: $token
    ) {
      buyer {
        auth {
          accessToken
        }
        userId
      }

      flags {
        is3DSecureRequired
      }

      fundingOptions {
        fundingInstrument {
          id
          name
          type
        }
      }

      paymentContingencies {
        threeDomainSecure(experiences: $supportedThreeDsExperiences) {
          status
          redirectUrl {
            href
          }
          method
          parameter
          experience
          requestParams {
            key
            value
          }
        }
      }
    }
  }
`;
